import styled from "styled-components"

const StyledMotivation = styled.section`
  background-color: #fff;
  padding: 160px 0 155px;
  .motivation-container {
    text-align: center;
    max-width: 1226px;
    margin: 0 auto;
  }
  .motivation-header {
    max-width: 635px;
    margin: 0 auto 155px;
    .title {
      margin: 40px 0 29px;
    }
  }
  .motivation-boxes {
    display: flex;
    justify-content: space-between;
    .motivation-box {
      flex-basis: 344px;
      max-width: 344px;
      .box-image {
        display: flex;
        justify-content: center;
        align-items: flex-start;
        min-height: 105px;
        svg {
          max-height: 71px;
        }
      }
      .box-text {
        p {
          font-size: 24px;
          line-height: 31px;
        }
      }
    }
  }
  @media screen and (max-width: 1400px) {
    padding: 140px 0 150px;
    .motivation-header {
      margin: 0 auto 58px;
      .title {
        margin: 30px 0 29px;
      }
    }
    .motivation-boxes {
      .motivation-box {
        flex-basis: 303px;
        max-width: 303px;
      }
    }
  }
  @media screen and (max-width: 900px) {
    padding: 65px 0 70px;
    .motivation-boxes {
      flex-direction: column;
      align-items: center;
      .motivation-box {
        flex-basis: 100%;
        max-width: 303px;
        &:not(:last-child) {
          margin-bottom: 40px;
        }
      }
    }
  }
  @media screen and (max-width: 600px) {
    .motivation-header {
      max-width: 100%;
      margin: 0 auto 60px;
      .title {
        margin: 20px 0;
        font-size: 34px;
        line-height: 43px;
      }
    }
    .motivation-boxes {
      flex-direction: column;
      align-items: center;
      .motivation-box {
        &:not(:last-child) {
          margin-bottom: 40px;
        }
        .box-image {
          min-height: 100px;
          svg {
            max-width: 61px;
          }
        }
        .box-text {
          max-width: 250px;
        }
      }
    }
  }
`

export default StyledMotivation
